import api from "../../api.js";

export async function fetchReverseStock(params = {}) {
  const {
    tab = 'Pending',
    department,
    fromDate,
    toDate,
    page = 1,
    pageSize = 20,
    branchcode,
  } = params;

  const query = new URLSearchParams();
  if (tab) query.set('tab', tab);
  if (department) query.set('department', department);
  if (fromDate) query.set('fromDate', fromDate);
  if (toDate) query.set('toDate', toDate);
  if (page) query.set('page', String(page));
  if (pageSize) query.set('pageSize', String(pageSize));
  if (branchcode) query.set('branchcode', branchcode);

  const res = await api.get(`/api/reverse-stock?${query.toString()}`);
  return res.data;
}

export async function returnToInventory(returnid, payload = {}) {
  const res = await api.post(`/api/reverse-stock/${returnid}/return-to-inventory`, payload);
  return res.data;
}

export async function fetchReverseStockDetails({ processscriptnumber, prescriptionid, department, tab, daysBack }) {
  const qs = new URLSearchParams();
  if (processscriptnumber) qs.set('processscriptnumber', processscriptnumber);
  if (prescriptionid) qs.set('prescriptionid', String(prescriptionid));
  if (department) qs.set('department', department);
  if (tab) qs.set('tab', tab);
  if (daysBack != null) qs.set('daysBack', String(daysBack));
  const res = await api.get(`/api/reverse-stock/details?${qs.toString()}`);
  return res.data;
}

export async function createReverseStock(payload) {
  // payload: { prescriptionid, items: [{ prescriptiondrugid, drugsku, quantityreturned }], reason?, returndate?, repeatid? }
  const res = await api.post('/api/reverse-stock', payload);
  return res.data;
}

